import React from 'react';

import useErnie from 'shared/hooks/use-ernie';
import { ERNIE_TYPES } from 'shared/constants';
import useUser from 'src/hooks/use-user';

import { CompleteAccountForm } from 'src/payments/components/complete-account-form/complete-account-form';
import { EnrollmentSteps } from 'src/payments/constants';
import { useTrackEnrollmentStepViewed } from 'src/payments/hooks/use-dutchie-pay-analytics/use-track-enrollment-step-viewed';

export const CompleteAccount = (): JSX.Element => {
  const User = useUser();
  const showErnie = useErnie();
  const completeAccountFormRef = useTrackEnrollmentStepViewed({ step: EnrollmentSteps.completeAccount });

  const onSuccess = (): void => {
    User.refetch();
    showErnie('Account updated successfully.', ERNIE_TYPES.SUCCESS);
  };

  return (
    <div ref={completeAccountFormRef}>
      <CompleteAccountForm onSuccess={onSuccess} />
    </div>
  );
};
